export const filterAnnotationsByReferences = (annotations, references) =>
  annotations.filter(({ highlight }) => references.includes(highlight.item));

export const getColumnElement = (learnosityItemElement, columnClass) =>
  learnosityItemElement.querySelector(columnClass);

export const sanitizeQuerySelector = (selector) => selector.replace(/;.*$/, '');

export const isHighlightInColumn = (highlight, columnElement) => {
  const selector = sanitizeQuerySelector(highlight.path);
  return columnElement.querySelector(selector) !== null;
};

export const getColumnAnnotations = (
  columnClass,
  learnosityItemElement,
  annotations,
) => {
  const columnElement = getColumnElement(learnosityItemElement, columnClass);
  return annotations.filter((annotation) =>
    isHighlightInColumn(annotation.highlight, columnElement),
  );
};

export const sortAnnotationsById = (annotations) =>
  annotations.sort((a, b) => a.id - b.id);

export const processAnnotations = (
  learnosityItemElement,
  annotationsWithCommonSharedPassageId,
  learnosityItemReferenceAnnotations,
) => [
  ...getColumnAnnotations(
    'div.two-columns.left-column',
    learnosityItemElement,
    annotationsWithCommonSharedPassageId,
  ),
  ...getColumnAnnotations(
    'div.two-columns.right-column',
    learnosityItemElement,
    learnosityItemReferenceAnnotations,
  ),
];

export const getCurrentAnnotations = (annotations, learnosityItemReference) => {
  const learnosityItemReferenceAnnotations = filterAnnotationsByReferences(
    annotations,
    [learnosityItemReference],
  );
  const learnosityItemElement = getLearnosityItemElement(
    learnosityItemReference,
  );
  const sharedPassageId = getSharedPassageId(learnosityItemElement);

  let combinedAnnotations = learnosityItemReferenceAnnotations;
  if (sharedPassageId) {
    const commonSharedPassageReferences =
      getLearnosityItemReferencesWithCommonSharedPassageId(sharedPassageId);
    const annotationsWithCommonSharedPassageId = filterAnnotationsByReferences(
      annotations,
      commonSharedPassageReferences,
    );
    combinedAnnotations = processAnnotations(
      learnosityItemElement,
      annotationsWithCommonSharedPassageId,
      learnosityItemReferenceAnnotations,
    );
  }
  return sortAnnotationsById(combinedAnnotations);
};

export const getLearnosityItemElement = (learnosityItemReference) =>
  document.querySelector(
    `.bluebook-player-inner-container div[data-reference="${learnosityItemReference}"`,
  );

export const getSharedPassageId = (learnosityItemElement) => {
  if (
    learnosityItemElement &&
    hasTwoColumns(learnosityItemElement) &&
    hasSharedPassage(learnosityItemElement)
  ) {
    return (
      learnosityItemElement
        .querySelector('div.two-columns.left-column')
        ?.getAttribute('data-lrn-widget-container') || null
    );
  }
  return null;
};

export const hasSharedPassage = (learnosityItemElement) =>
  !!learnosityItemElement.querySelector(
    'div.left-column div.lrn_sharedpassage',
  );

export const hasTwoColumns = (element) => {
  const leftColumn = element.querySelector('.two-columns.left-column');
  const rightColumn = element.querySelector('.two-columns.right-column');
  return leftColumn !== null && rightColumn !== null;
};

export const getLearnosityItemReferencesWithCommonSharedPassageId = (
  sharedPassageId,
) =>
  Array.from(
    document.querySelectorAll(
      `div[data-lrn-widget-container="${sharedPassageId}"]`,
    ),
  )
    .map((element) =>
      element.closest('.learnosity-item')?.getAttribute('data-reference'),
    )
    .filter(Boolean);
